import React from "react";
import styled from "styled-components";
import SyncIcon from "@mui/icons-material/Sync";
import Button from "@mui/material/Button";

const OverviewButton = styled(Button)`
    background-color: ${({ theme }) => theme.palette.background.default};
    font-size: 11px;
    z-index: 10;
    text-align: center;
    padding-right: 12px;
    height: 31px;
`;
const OverviewRefreshButton = ({ setRefresh }) => {
    return (
        <OverviewButton
            variant="outlined"
            color="secondary"
            startIcon={<SyncIcon />}
            onClick={() => setRefresh(true)}
        >
            Refresh overview
        </OverviewButton>
    );
};

export default OverviewRefreshButton;
